import VerifyCheck from '@/views/Check/VerifyCheck.vue'

const routes = {
  path: '/verify',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/verify/:token',
      name: 'Verificar ponto',
      component: VerifyCheck,
      props: true,
    },
  ],
}

export default routes
